import React from 'react';
import useRewriteUrl from '../../../hooks/useRewriteUrl';
import MarketPricesByCatalogue from './marketPricesByCatalogue';

function ListFollowingMarketPrice({ listFollowingMarketPrices }) {
  useRewriteUrl();

  return (
    <>
      <MarketPricesByCatalogue data={listFollowingMarketPrices} tab="market-prices-like"/>
    </>
  );
}

export default ListFollowingMarketPrice;
